import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import "./config/i18n";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <App />
);

